import type { EllipseI, ItemI, TickerI } from "tweenly"
import AbstractContainer from "./AbstractContainer"

interface Props {
    object: ItemI | EllipseI | TickerI
    isHiding: boolean
    isLocking: boolean
    isRootTicker: boolean
    canvasScaleCoef: number
    borderCoef: number
    handleSelectObject: (
        event: React.MouseEvent,
        objectId: string,
        animationIds: string[],
        multiSelectKey: boolean
    ) => void
}
const ItemContainer = ({
    object,
    isHiding,
    isLocking,
    isRootTicker,
    canvasScaleCoef,
    borderCoef,
    handleSelectObject,
}: Props) => {
    return (
        <AbstractContainer
            object={object}
            isHiding={isHiding}
            isLocking={isLocking}
            isRootTicker={isRootTicker}
            canvasScaleCoef={canvasScaleCoef}
            borderCoef={borderCoef}
            handleSelectObject={handleSelectObject}
            className={"item-container"}
            visibility={object.isHidden || isHiding ? "hidden" : "visible"}
        />
    )
}

export default ItemContainer
